

import { useState } from "react";
import { Card } from '@mui/material';
import { Box, Button, Divider, Grid, MenuItem, TextField, Typography } from "@mui/material";
import api from "../../../../../services/api";
import MessageSuccess from "../../../../../messages/messageSuccess";
import MessageError from "../../../../../messages/messageError";
import { useDispatch, useSelector } from "react-redux";
import HeaderGestorConfigs from "../../../../../utils/headerGestorConfigs";
import ButtonLeft from "../../../../../utils/buttonLeft";
import FazerObservacoes from "../../../../components/fazerObservacoes.";
import TextoFormatado from "../../../../../utils/textoFormatado";
import AddImagens from "./addImagens";
import DeleteAnalise from "./deleteAnalise";


export default function AnaliseCromatografia({ avaliacaoId, ficha, analises, handleClose }) {
    // const { avaliacaoId } = useParams()
    const dispatch = useDispatch()
    const [avaliacao, setAvaliacao] = useState()
    const [messageSuccess, setMessageSuccess] = useState('')
    const [messageError, setMessageError] = useState('')
    const [open, setOpen] = useState(false);
    const [obs, setObs] = useState('')
    const user = useSelector(state => state.account.user);

    function HandleChange(e) {
        setAvaliacao((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    }

    const submitAvaliacao = async () => {

        setOpen(true)
        setMessageSuccess('')
        setMessageError('')
        // console.log(avaliacao)

        const formData = new FormData();
        formData.append('userId', user?._id);
        formData.append('avaliacaoAnaliticaId', avaliacaoId);
        formData.append('observacao', obs);
        formData.append('intesidadeMancha', avaliacao?.intesidadeMancha ?? '');
        formData.append('metodo', avaliacao?.metodo ?? '');
        formData.append('resultado', avaliacao?.resultado ?? '');
        if (avaliacao?.imagens) {
            for (let imagem of avaliacao?.imagens) { formData.append('imagens', imagem ?? ''); }
        }
        await api.patch('/avalicao-analitica/teste/cromatografia', formData)
            .then(res => {
                setMessageSuccess(res.data.msg)
                dispatch({
                    type: 'alert',
                    payload: { alert: 'Análise inserida com sucesso' },
                });
                handleClose();

            }).catch(err => {
                setMessageError(err.response.data.message)
            }).finally(() => setOpen(false))
    }

    const renderField = (label, value) => (
        <Grid item xs={12} sm={6}>
            <Box>
                <Typography variant="caption" color="text.secondary">
                    {label}
                </Typography>
                <Typography variant="body1">
                    {value || 'Não informado'}
                </Typography>
            </Box>
        </Grid>
    );
    return (
        <Card style={{ padding: 15, marginTop: 20, minWidth: 700 }}>
            {messageSuccess && <MessageSuccess message={messageSuccess} />}
            {messageError && <MessageError message={messageError} />}

            <HeaderGestorConfigs title={'Analise de Cromatografia'} />
            {ficha ?
                < >
                <DeleteAnalise url={'/avalicao-analitica/delete/teste/cromatografia'} id={avaliacaoId} />
                    <Box  sx={{ backgroundColor: 'rgba(0, 0, 0, 0.03)', padding: '2rem', borderRadius: '4px', mb: 4 }}>
                        <Grid container spacing={2}>
                            {renderField('Intensidade de Mancha', analises.intesidadeMancha)}
                            {renderField('Metodo', analises.metodo)}
                            {renderField('Resultado', analises.resultado)}
                        </Grid>
                    </Box>
                    <Box sx={{ backgroundColor: 'rgba(0, 0, 0, 0.03)', padding: '2rem', borderRadius: '4px', mb: 4 }}>
                        <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Observação:</strong>  <TextoFormatado texto={analises?.observacao ?? ''} /> </Typography>
                    </Box>

                    <Box sx={{ backgroundColor: 'rgba(0, 0, 0, 0.03)', padding: '2rem', borderRadius: '4px', mb: 4 }}>
                        <AddImagens avaliacao={analises} />
                    </Box>
                </>
                :
                <>
                    <Grid container >
                        <Grid xs={12} md item m={1}>
                            <TextField
                                type="text"
                                label="Intensidade de Mancha"
                                fullWidth
                                size="small"
                                name="intesidadeMancha"
                                variant="outlined"
                                onChange={HandleChange}
                                defaultValue={avaliacao?.intesidadeMancha}
                            />
                        </Grid>

                        <Grid xs={12} md item m={1}>
                            <TextField
                                type="text"
                                label="Metodo"
                                fullWidth
                                size="small"
                                name="metodo"
                                variant="outlined"
                                onChange={HandleChange}
                                defaultValue={avaliacao?.metodo}
                            />
                        </Grid>

                        <Grid xs={12} md item m={1}>
                            <TextField
                                type="text"
                                label="Resultado"
                                select
                                fullWidth
                                size="small"
                                name="resultado"
                                variant="outlined"
                                onChange={HandleChange}
                                defaultValue={avaliacao?.resultado || ''}
                            >
                                <MenuItem value={'Aprovado'} name="resultado">
                                    Aprovado
                                </MenuItem>
                                <MenuItem value={'Reprovado'} name="resultado">
                                    Reprovado
                                </MenuItem>
                            </TextField>
                        </Grid>
                    </Grid>

                    <FazerObservacoes setObs={setObs} obs={obs} titulo={''} />

                    <AddImagens
                        addImagens={true}
                        avaliacao={avaliacao}
                        setAvaliacao={setAvaliacao}
                    />

                    <ButtonLeft
                        title={'Salvar'}
                        funcao={submitAvaliacao}
                        load={open}
                    >
                        <Button onClick={handleClose} color="warning" size="small" style={{ marginTop: 20, marginRight: 10 }}>Cancelar</Button>
                    </ButtonLeft>
                </>
            }
        </Card>
    )
}